import { gql } from '@apollo/client'

const betItemSingleGameParlayMetaData = gql`
  fragment BetItemSingleGameParlay on Parlay {
    id
    legTypesTaken
    numberOfLegs
    won
  }
`

const betItemSingleGameBountyMetaData = gql`
  fragment BetItemSingleGameBounty on Bounty {
    ranges {
      bountyIncrement
      bountyRange {
        linesValue
        type
      }
      bountyTimesAchievable
      payoutMultiplier
    }
  }
`

const betItemMultiGameParlayMetaData = gql`
  fragment BetItemMultiGameParlayItem on MultiGameParlay {
    failuresAllowed
    successesRequired
    legs {
      achievedValue {
        metBetObjective
        type
        value
      }
      updatedAt
      insertedAt
      id
      matchId
      order
      status
    }
    payouts {
      payout
      payoutMultiplier
      requirements {
        goal
        requirement
      }
      win
    }
    requirements {
      lineType
      title
      titleDisplayStrategy
    }
  }
`

const apexStats = gql`
  fragment ApexStats on Apex {
    legendUsed
    matchEndDate
    playerKills
    playerRankScoreChange
    playerTimesPlacedTopThree
  }
`

const specialRules = gql`
  fragment SpecialRules on SpecialRules {
    id
    systemId
    ruleDisplay
  }
`

export const betItemFragment = gql`
  fragment BetItem on BetItem {
    achievedMultiplier
    achievedValue
    percentageOfBet
    betAmount
    betType
    currencyType
    events {
      event
      insertedAt
      updatedAt
    }
    gameData {
      apexLegend
      gameMode
      map
      squadSize
    }
    metadata {
      singleGameParlay {
        ...BetItemSingleGameParlay
      }
      singleGameBounty {
        ...BetItemSingleGameBounty
      }
      multiGameParlay {
        ...BetItemMultiGameParlayItem
      }
      specialRules {
        ...SpecialRules
      }
      specialRulesApplied
    }
    fundingSources {
      amount
      wallet
    }
    payoutAmounts {
      amount
      wallet
    }
    matches
    matchStats {
      __typename
      ...ApexStats
    }
    gameSlug
    id
    insertedAt
    level
    linesValue
    matchId
    payout
    payoutMultiplier
    refundCurrencyType
    refundReason
    refunded
    resolutionMethod
    resolved
    title
    type
    updatedAt
    won
  }
  ${betItemSingleGameParlayMetaData}
  ${betItemSingleGameBountyMetaData}
  ${betItemMultiGameParlayMetaData}
  ${apexStats}
  ${specialRules}
`
